export default [
  {
    uid: 'ouzel-overview',
    label: 'Ouzel Overview',
    date: '2019-10-01',
    active: false,
    tags: ['ouzel','data management'],
  },
  {
    uid: 'ouzel-projects',
    label: 'Ouzel projects overview',
    date: '2019-10-01',
    active: false,
    tags: ['ouzel','projects','workflows']
  },
  {
    uid: 'field-monitoring-plans',
    label: 'Custom field monitoring plans',
    date: '2019-08-01',
    active: true,
    tags: ['monitoring', 'acorns', 'remote-sensing']
  },
  {
    uid: 'spatial-data-management',
    label: 'Spatial Data Library',
    date: '2019-07-24',
    active: true,
    tags: ['acorns','spatial']
  },
  {
    uid: 'ouzel-background',
    label: 'Ouzel Background',
    date: '2019-07-01',
    active: false,
    tags: ['ouzel','projects']
  },
  {
    uid: 'ouzel-contacts',
    label: 'Ouzel contacts overview',
    date: '2019-10-01',
    active: false,
    tags: ['ouzel','contacts','workflows']
  },
  {
    uid: 'ouzel-issues',
    label: 'Ouzel issues overview',
    date: '2019-10-01',
    active: false,
    tags: ['ouzel','issues','workflows']
  },
  {
    uid: 'centralized-data',
    label: 'Keeping your data all in one place',
    date: '2019-06-01',
    active: false,
    tags: ['data management', 'acorns']
  },
  {
    uid: 'acorns-platform',
    label: 'The ACORNS platform',
    date: '2019-05-01',
    active: true,
      tags: ['acorns','data management']
  },
  {
    uid: 'acorns-projects',
    label: 'The ACORNS project structure',
    date: '2019-05-01',
    active: true,
      tags: ['acorns','tools','projects']
  },
  {
    uid: 'acorns-tools',
    label: 'The ACORNS tool library',
    description: 'Tools are a way to expand the functionality of an ACORNS application. There are numerous tools that come standard and then new tools can be created as needed.',
    date: '2019-08-01',
    active: false,
    tags: ['acorns','tools']
  },
  {
    uid: 'map-tool',
    label: 'The ACORNS map tool',
    date: '2019-05-01',
    active: false,
    tags: ['acorns','tools','spatial']
  },
  {
    uid: 'dataset-tool',
    label: 'The ACORNS dataset tool',
    date: '2019-05-01',
    active: false,
    tags: ['acorns','tools','data management']
  },
  {
    uid: 'document-tool',
    label: 'The ACORNS document tool',
    date: '2019-05-01',
    active: false,
    tags: ['acorns','tools','documents']
  },
  {
    uid: 'data-reports',
    label: 'Customizable reports in ACORNS',
    date: '2019-05-01',
    active: false,
    tags: ['acorns','reports']
  },
  {
    uid: 'data-qc',
    label: 'The importance of reviewing and flagging data',
    date: '2019-05-01',
    active: false,
    tags: ['acorns','data management','flagging']
  },
  {
    uid: 'extending-acorns',
    label: 'Extend ACORNS with integrations',
    date: '2019-05-01',
    active: false,
    tags: ['acorns','integrations']
  },
  {
    uid: 'model-gui',
    label: 'Use ACORNS as your modeling platform',
    date: '2019-05-01',
    active: false,
    tags: ['acorns','modeling']
  },
  {
    uid: 'data-access',
    label: 'Data Access and availabilty',
    date: '2019-05-01',
    active: false,
    tags: ['acorns','data management']
  },
  {
    uid: 'r-code',
    label: 'R language: Custom R code',
    date: '2019-05-01',
    active: true,
    tags: ['R','code']
  },
  {
    uid: 'unit-testing',
    label: 'Code testing and review is for everyone',
    date: '2019-08-01',
    active: false,
    tags: ['code']
  },
  {
    uid: 'data-science-workshops',
    label: 'Data science workshops',
    date: '2019-08-01',
    active: true,
    tags: ['code', 'workshops']
  },
].map( d => ({ ...d, route: `/notes/${d.uid}` }));
